import React, { Component } from 'react';
import { isNullOrUndefined, isUndefined } from "util";
import TextField from '@material-ui/core/TextField';

class TechStackSearchFilter extends React.Component {
    
    constructor(props){

        super(props);
        //techStackKey, handleTechStackKeyChange, techStackKeyName

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event){

        let keyWord = event.target.value;
        if(!isNullOrUndefined(keyWord)){
            keyWord = keyWord.replace("\n","");
        }
        if(!isNullOrUndefined(this.props.handleTechStackKeyChange))
            this.props.handleTechStackKeyChange(this.props.techStackKeyName, keyWord); 
    }

    render(){
        return (
            <div>
                <div style={{marginTop:'5px', textAlign:'center'}}>
                    <form>
                        <label>
                            <TextField 
                                type="text"
                                variant="outlined"
                                multiline
                                label = "Search"
                                placeholder = "Search"
                                value={this.props.techStackKey}
                                onChange={(e) => { this.handleChange(e)}}
                                onKeyDown={(e) => {
                                }}
                                rowsMax="2"
                                rowsMin="1"
                                style={{
                                    background: 'white',
                                    marginTop:'6px',
                                    marginBottom:'6px',
                                    width:'95%',
                                    maxWidth:'550px',
                                    minWidth: '200px'
                                    }}/>
                        </label>
                    </form>
                </div>
            </div>
        )
    }
}
export default TechStackSearchFilter;